
import * as Action from "@/../src-gen/action";
import FDataTableMDP, { ActionType } from "@/components/table/FDataTableMDP";
import FCellCopyMDP from "@/components/table/cell/FCellCopyMDP";
import FCellDateTimeMDP from "@/components/table/cell/FCellDateTimeMDP";


export default class CFEMandateListFDataTableMDP extends FDataTableMDP {
    parent: any;
    constructor(props: { parent: any, taskRoot?: any }) {
        super({ myRefName: "CFEMandateListFDataTableRef", title: "EMandate List", disabled: props.taskRoot?.taskStateTerminated , enableShowHideColumns: true, itemKey: "eMandateId",showFiltersByDefault: false });
        this.parent = props.parent;
        this.addColumn({
            label: "Nupay Cust Id",
            dataSelectorKey: "remoteEMandateId",
            columnCellMDP: new FCellCopyMDP({
                dataSelectorKeyToCopy: "selfEnrolEMandateLink",
                tooltipText: "Click here to copy the EMandate link"
            })
        }).addColumn({
            label: "IFSC Code",
            dataSelectorKey: "ifscCode",
        })
            .addCurrencyColumn({
                dataSelectorKey: "amount",
                label: "Amount"
            })
            .addEMandateStatusColumn({ label: "Status", dataSelectorKey: "status.name", })
            .addStatusColumn({
                dataSelectorKey:"authMode.name",
                label:"Auth Mode",
            })
            .addColumn({
                label:"UPI App",
                dataSelectorKey:"remoteEMandateDetails.upiApp",
                hidden: true
            })
            .addBooleanColumn({
                label:"UPI",
                dataSelectorKey:"isUPIMandate",
                successColor: "primary",
                errorColor:"grey",
                outlined: true,
                enableFilter:false

            })
            .addPaymentProviderColumn({
                label: "Provider",
                dataSelectorKey: "provider.name",
                hidden: true
            }).addNumberColumn({
                label: "Account Number / UPI ID",
                dataSelectorKey: "accountNumber",

            }).addColumn({
                label: "Created On",
                dataSelectorKey: "createdOn",
                columnCellMDP: new FCellDateTimeMDP(),
                sortable: true
            })
            .addBooleanColumn({
                label: "Default",
                dataSelectorKey: "isDefault",
                enableFilter:false
            })


            .addAction({
                label: "Initiate EMandate",
                onClick: this.handleInitiateClick(),
                type: ActionType.ADD,
            }).addAction({
                label: "Refresh",
                onClick: this.handleRefreshClick(),
                type: ActionType.REFRESH,
                noSelect: true
            })
            
            
    }

    handleInitiateClick() {
        return () => {
            return new Promise(res => {
                this.parent.prepopulateDetails();
                this.parent.showInitiateForm = true;
                res(true)
            })
        }
    }
    handleRefreshClick() {
        return () => {
            return new Promise(res => {
                Action.ClientFile.GetAllEMandateList.execute1(this.parent.clientFileId, output => {
                    res(true);
                });
            }
            )
        }
    }
}